import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { CandidateLayout } from "layouts/pages/CandidateLayout";

import { TypeformInvisalign } from "components/Typeform/constants";
import { checkIsNotFound } from "configs/unsupport-locale-routes";
import { UrlsConfig } from "configs/urlsConfig";
import { Theme } from "constants/enum";
import { serverSideTranslations } from "utils/next/translations";

export default function CandidateInvisalign() {
    const { t } = useTranslation("candidate");

    return (
        <CandidateLayout title={t("title")} typeformIds={TypeformInvisalign} />
    );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    if (checkIsNotFound(UrlsConfig.CANDIDATE_INVISALIGN, locale)) {
        return { notFound: true };
    }

    return {
        props: {
            ...(await serverSideTranslations(locale, ["global", "candidate"])),
            withHeader: false,
            withFooter: false,
            key: locale,
            themeType: Theme.SYT,
        },
    };
};
